var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 20,
    viewBox: "0 0 51 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12220_671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.646 12.6769H43.7383V14.4615H45.646V12.6769Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 14.4615H41.9541V16.3692H43.7387V14.4615Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9541 16.3693H40.0464V18.1539H41.9541V16.3693Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 9H40V11H42V9Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1538 8.98462H47.3691V10.7692H49.1538V8.98462Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 10.7693H45.646V12.677H47.3691V10.7693Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 7.2616H45.646V8.98467H47.3691V7.2616Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8247 9H35V11H36.8247H38.4197H40V9H38.4197H36.8247Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 3.56921H41.9541V5.35383H43.7387V3.56921Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9541 1.72302L40.0464 1.72302V3.56918H41.9541V1.72302Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 9H27V11H29V9Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.64 9H19.8517H18V11H19.8517H21.64H23.4283H25V9H23.4283H21.64Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.646 5.35388H43.7383V7.26157H45.646V5.35388Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1438 9H29V11H31.1438H33.1589H35V9H33.1589H31.1438Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 9H25V11H27V9Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9H16.3561H14.5576H12.7597H10.9618L9.16391 9H7.45624H5.65774H3.86045H2L2 11H3.86045H5.65774H7.45624H9.16391L10.9618 11H12.7597H14.5576H16.3561H18V9Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1538 10.7693H47.3691V12.677H49.1538V10.7693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 12.6769H45.646V14.4615H47.3691V12.6769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 8.98462H45.646V10.7692H47.3691V8.98462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.646 14.4615H43.7383V16.3692H45.646V14.4615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.646 10.7693H43.7383V12.677H45.646V10.7693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.646 7.2616H43.7383V8.98467H45.646V7.2616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 16.3693H41.9541V18.1539H43.7387V16.3693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 12.6769H41.9541V14.4615H43.7387V12.6769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 5.35388H41.9541V7.26157H43.7387V5.35388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.954 18.1539H40.0463V16.3693H38.2617V18.1502V20H40.1546H41.954V18.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9541 14.4615H40.0464V16.3692H41.9541V14.4615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5398 11H39.0472L37.6295 11H36.0619H34.6437H33.1511H31.6584H30.1658H28.6732H27.2549H25.7623H24.2697L22.777 11H21.3593H19.8662H18.3735H16.8809H15.3883H13.9705H12.4774H10.9853H9.49214L8.07441 11H6.50687H5.08914H3.5965H2L2 13H3.5965H5.08914H6.50687H8.07441H9.49214L10.9853 13H12.4774H13.9705H15.3883H16.8809H18.3735H19.8662H21.3593H22.777L24.2697 13H25.7623H27.2549H28.6732H30.1658H31.6584H33.1511H34.6437H36.0619H37.6295H39.0472L40.5398 13H42V11H40.5398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9541 3.56921L40.0464 3.56921V5.35383H41.9541V3.56921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 8.98462H49.1538V10.7692H51V8.98462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1538 7.2616H47.3691V8.98467H49.1538V7.2616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 5.35388H45.646V7.26157H47.3691V5.35388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.646 3.56921L43.7383 3.56921V5.35383H45.646V3.56921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 8.98462H41.9541V10.7692H43.7387V8.98462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7387 1.72302L41.9541 1.72302V3.56918H43.7387V1.72302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 7L40.5398 7H39.0472H37.6295H36.0619H34.6437L33.1511 7H31.6584H30.1658H28.6732L27.2549 7H25.7623H24.2697H22.777H21.3593L19.8662 7H18.3735H16.8809H15.3883H13.9705L12.4774 7H10.9853H9.49214H8.07441H6.50687L5.08914 7H3.5965H2L2 9H3.5965H5.08914H6.50687H8.07441H9.49214L10.9853 9H12.4774H13.9705H15.3883H16.8809H18.3735H19.8662H21.3593H22.777L24.2697 9H25.7623H27.2549H28.6732H30.1658H31.6584H33.1511H34.6437H36.0619H37.6295H39.0472L40.5398 9H42V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1546 0L38.2617 0V1.68738V3.56923H40.0463V1.72308L41.954 1.72308V0L40.1546 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9H0L0 11H2L2 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12220_671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.915777064f379559f7c476d981b4be45.svg";
export { ForwardRef as ReactComponent };